<script>
export default {
  data() {
    return {
      images: [],
      files: [],
      errorTypeFile: false,
      item: {},
      index: 0,
    };
  },

  props: ["getUrl", "postUrl"],

  mixins: [],

  computed: {
    totalFiles: function () {
      return this.images.length + this.files.length;
    },
  },

  created() {},

  mounted() {
    this.getData();
  },

  watch: {},

  methods: {
    getData() {
      axios
        .get(this.getUrl, {
          params: {},
        })
        .then((response) => {
          this.images = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleFileUpload() {
      if (this.correctFile(this.$refs.file1.files[0])) {
        this.files.push(this.$refs.file1.files[0]);
      }
    },

    correctFile(file) {
      if (file.type.substring(0, 6) == "image/") {
        this.errorTypeFile = false;
        return true;
      } else {
        this.errorTypeFile = true;
        return false;
      }
    },

    submitFiles() {
      let formData = new FormData();

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }

      axios
        .post(this.postUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.images = response.data.data;
            this.files = [];
            this.$root.$refs.toastr.s(response.data.message);
          } else {
            this.$root.$refs.toastr.e(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$root.$refs.toastr.e("ERROR");
        });
    },

    toggleDeleteModal(item, index) {
      this.item = item;
      this.index = index;
      $("#deleteImageModal").modal("show");
    },

    deleteItem() {
      axios
        .delete(this.item.delete_url)
        .then((response) => {
          this.images = response.data.data;
          this.$root.$refs.toastr.s(response.data.message);
          $("#deleteImageModal").modal("hide");
        })
        .catch((error) => {
          console.log(error);
          this.$root.$refs.toastr.e("ERROR");
        });
    },
  },

  components: {},
};
</script>
